import { PageableResult } from '../models/common';
import BaseService from './BaseService';
import {
  CreateNotificationRuleCommand,
  CreateNotificationRulesCommand,
  NotificationRuleViewModel,
  UpdateNotificationRuleCommand,
  UpdateNotificationRulesCommand
} from '../models/notification-rule';

export class NotificationRulesService extends BaseService {
  url = `/notification-rules`;

  getRules = async (page: number, size: number): Promise<PageableResult<NotificationRuleViewModel>> => {
    const query = this.BuildQueryString({ page, size });
    const result = await this.Fetch(`${this.url}?${query}`, 'GET');

    return this.FromResult<PageableResult<NotificationRuleViewModel>>(result);
  };

  createNotificationRule = async (command: CreateNotificationRuleCommand): Promise<string> => {
    const result = await this.Fetch(`${this.url}`, 'POST', JSON.stringify(command));

    return this.FromResult<string>(result);
  };

  updateNotificationRule = async (command: UpdateNotificationRuleCommand): Promise<string> => {
    const result = await this.Fetch(`${this.url}`, 'PUT', JSON.stringify(command));

    return this.FromResult<string>(result);
  };

  createNotificationRules = async (command: CreateNotificationRulesCommand): Promise<string[]> => {
    const result = await this.Fetch(`${this.url}/multiple`, 'POST', JSON.stringify(command));

    return this.FromResult<string[]>(result);
  };

  updateNotificationRules = async (command: UpdateNotificationRulesCommand): Promise<string[]> => {
    const result = await this.Fetch(`${this.url}/multiple`, 'PUT', JSON.stringify(command));

    return this.FromResult<string[]>(result);
  };

  deleteRule = async (id: string) => {
    const query = this.BuildQueryString({ id });
    const result = await this.Fetch(`${this.url}?${query}`, 'DELETE');
    return this.FromResult(result);
  };
}

export default NotificationRulesService;
